export default function Contacts() {
  return (
    <div>
      <h2 className="text-lg font-semibold text-text_primary mb-1">Contacts</h2>
      <p className="text-sm text-text_muted">Manage your subscriber contacts.</p>
    </div>
  );
}
